import { useCallback, useContext } from "react";
import { ModalsWrapperContext } from "@kanda-libs/ks-component-ts";
import useGetCheckoutUrl from "hooks/useGetCheckoutUrl";
import { MODAL_ID } from "components/job/JobLayout/JobActions/CheckoutUrl/constants";
import { useSelector } from "react-redux";
import { selectors } from "store";
import jobSelectors from "store/selectors/job";

export interface CheckoutUrlPropsHook {
  onClick: () => void;
  isSubmitting: boolean;
  url: string;
  isLoading: boolean;
}

export default function useCheckoutUrlProps(): CheckoutUrlPropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);

  const { getLinks, links, isSubmitting } = useGetCheckoutUrl();

  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(() => {
    if (!job) return;
    getLinks(job?.id, () => showModal(MODAL_ID));
  }, [job, getLinks, showModal]);

  return {
    onClick,
    isSubmitting,
    url: links?.checkout_url || "No link available",
    isLoading,
  };
}
